import React from "react";
import moment from "moment";

const FileMenuItem = ({ item, isActive, onClick }) => (
    <tr
        id={`file-manager-file-${item.fileId}`}
        className={`g-pointer ${isActive ? "bg-primary text-light" : ""}`}
        onClick={onClick}
    >
        <td>
            {item.fileName}
        </td>
        <td>
            {moment(item.uploadDate).format("YYYY-MM-DD")}
        </td>
    </tr>
);

export default FileMenuItem;
